/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.home';

export default defineMessages({
  welcome: {
    id: `${scope}.welcome`,
    defaultMessage: 'Welcome back',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Home',
  },
  pageTitle: {
    id: `${scope}.page.title`,
    defaultMessage: 'Workspace',
  },
  pageDescription: {
    id: `${scope}.page.description`,
    defaultMessage: 'CDP Workspace',
  },
  goodEvening: {
    id: `${scope}.page.greeting.evening`,
    defaultMessage: 'Good evening, {name}',
  },
  goodMorning: {
    id: `${scope}.page.greeting.morning`,
    defaultMessage: 'Good morning, {name}',
  },
  goodAfternoon: {
    id: `${scope}.page.greeting.afternoon`,
    defaultMessage: 'Good afternoon, {name}',
  },
  dismissMessage: {
    id: `${scope}.page.dismissMessage`,
    defaultMessage: 'Dismiss message',
  },
});
